// CANONICAL COPY (GH #7115). src/constants/obligations/obl-data-classification.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-data-classification',
  title: 'Verify data classification and labelling scheme is in place',
  description:
    'Confirm that a data classification and labelling scheme is documented and published, covering confidentiality, integrity and availability requirements. Information shall be classified according to its sensitivity and an appropriate set of procedures for labelling information — in physical and electronic form — shall be developed and implemented in line with the classification scheme.',
  category: 'assets',
  scfIds: ['SCF-AST-004', 'SCF-AST-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Data classification policy is published' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
